var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.30905 11.6978L1.99541 8.38648C1.62299 8.01431 1.02137 8.01431 0.648948 8.38648C0.276522 8.75865 0.276522 9.35984 0.648948 9.73201L4.64059 13.7209C5.01302 14.093 5.61463 14.093 5.98706 13.7209L16.0903 3.62465C16.4627 3.25248 16.4627 2.65129 16.0903 2.27913C15.7179 1.90696 15.1163 1.90696 14.7438 2.27913L5.30905 11.6978Z",
    fill: "#00FF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/greenTick.ff538814dd2708f87a55051f0b38a224.svg";
export { ForwardRef as ReactComponent };